/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  global-require,
  import/no-extraneous-dependencies
*/
// needed for react intl otherwise stuff busts

import Application from './detached-application';

require('intl');

module.exports = Application;

// All HelloSign components need to be attached to the application for legacy
// purposes.
Application.components = require('./components');

Application.mixins = {
  AdjustScrollingMixin: require('./components/api-docs/api-menu/adjust-scrolling-mixin'),
};
